import React, { useEffect, useState, useRef, useCallback } from "react";
import { useParams } from "react-router-dom";
import axios from 'axios';
import { Box, Typography, TextField, Button, Link, Dialog, DialogTitle, DialogContent, DialogActions, Avatar } from '@mui/material';
import logo from "../components/Logo/Colloquia_Logo.png";
import Tooltip from '@mui/material/Tooltip';
import { useLocation, useHistory } from 'react-router-dom';


function MainSocialCommentsPage() {
   const { id } = useParams();
   const [mainSocialPost, setMainSocialPost] = useState(null);
   const [comments, setComments] = useState([]);
   const [newComment, setNewComment] = useState('');
   const history = useHistory();
   const [open, setOpen] = useState(false);
   const [title, setTitle] = useState('');
   const [content, setContent] = useState('');


   const [openDialog, setOpenDialog] = useState(false);
   const [voteType, setVoteType] = useState(null); // "Pass" | "No Pass"
   const [comment, setComment] = useState("");
   const [activePostId, setActivePostId] = useState(null);


   const [replyOpen, setReplyOpen] = useState(false);
   const [replyText, setReplyText] = useState("");
   const [activeCommentId, setActiveCommentId] = useState(null);


   // fetch scotus case info
   useEffect(() => {
       axios.get(`/mainSocialPost/${id}`)
           .then(res => setMainSocialPost(res.data))
           .catch(err => console.error("Error loading case", err));
       }, [id]);

   /*
   // Fetch comments
   useEffect(() => {
   axios.get(`/mainSocialPost/${id}/comments`)
       .then(res => setComments(res.data))
       .catch(err => console.error("Error loading comments", err));
   }, [id]);
   */
    const [cursor, setCursor] = useState(null);
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);

    const fetchComments = async () => {
        if (loading || !hasMore) return;

        try {
            setLoading(true);

            const res = await axios.get(`/mainSocialPost/${id}/comments`, {
                params: { cursor, limit: 10 }
            });

            setComments(prev => {
                const existingIds = new Set(prev.map(c => c._id));
                const newComments = res.data.comments.filter(c => !existingIds.has(c._id));
                return [...prev, ...newComments];
            });

            setCursor(res.data.nextCursor);
            setHasMore(res.data.hasMore);

        } catch (err) {
            console.error("Error loading comments", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        setComments([]);
        setCursor(null);
        setHasMore(true);
    }, [id]);

    useEffect(() => {
        fetchComments();
    }, [id]);

    const observer = useRef();

    const lastCommentRef = useCallback(node => {
        if (loading) return;

        if (observer.current) observer.current.disconnect();

        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && hasMore) {
            fetchComments();
            }
        });

        if (node) observer.current.observe(node);
    }, [loading, hasMore]);

   const handleSubmitComment = async () => {
       if (!newComment.trim()) return;

       try {
           const res = await axios.post(`/mainSocialPost/${id}/comment`, { 
                text: newComment, 
                topic: mainSocialPost.topic, 
                topicType: mainSocialPost.topicType,
            }); // NOTE: single 'comment'

           //const commentRes = await axios.get(`/mainSocialPost/${id}/comments`);
           //setComments(prev => [commentRes.data, ...prev]);
           //setComments(commentRes.data);
           setComments(prev => [res.data, ...prev]);
           setNewComment('');
       } catch (err) {
           console.error("Error submitting comment", err);
       }
   };


   const toggleVote = async (postId) => {
       try {
           const res = await axios.post(`/post/${postId}/upvote`);
           const { upvotes, voted } = res.data;


           setMainSocialPost(prevCase => ({
               ...prevCase,
               upvotes,
               voted
           }));
       } catch (err) {
           console.error('Error toggling vote:', err);
       }
   };


   const handleOpenDialog = (scotusCaseId) => {
      setActivePostId(scotusCaseId);
      setOpenDialog(true);
   };


   const toggleCommentVote = async (commentId) => {
       try {
               // hit backend endpoint that toggles a vote
               const res = await axios.post(`/mainSocialPostComments/${commentId}/upvote`);


               // update <posts> in react state so ui rerenders
               // setPosts(prev => ...) receives the previous array of posts and must return a new array
               // prev.map( p => { ... } )
               // iterate through every post p in old array
               // if p is the one user just voted on, return a new object with the fresh upvote info from server
               // otherwise, return p unchanged
           /*setComments((prev) =>
               prev.map((p) =>
                   p._id === commentId
                       ? {
                           ...p, // copy exisiting post fields
                           upvotes: res.data.upvotes, // updated count
                           voted:   res.data.voted // true or false that user voted
                       }
                       : p // all other posts unchanged
               )
           );*/
            //const commentRes = await axios.get(`/mainSocialPost/${id}/comments`);
           //setComments(prev => [commentRes.data, ...prev]);
           //setComments(commentRes.data);
            setComments(prev =>
                prev.map(c =>
                    c._id === commentId
                    ? { ...c, upvotes: res.data.upvotes, voted: res.data.voted }
                    : c
                )
            );


       } catch(err) {
           console.error("Vote error", err);
       }
   };




   const handleReplyOpen = (commentId) => {
       setActiveCommentId(commentId);
       setReplyOpen(true);
   };




   const handleReplyClose = () => {
       setReplyOpen(false);
       setReplyText("");
       setActiveCommentId(null);
   };

   const visitProfile = (e, userId) => {
        e.stopPropagation(); // prevent opening the post
        history.push(`/user/view/${userId}`);
    };


   const handleReplySubmit = async () => {
       if (!replyText.trim()) return;


       try {
       const res = await axios.post(`/mainSocialPost/comments/${activeCommentId}/replies`, {
           text: replyText
       });


       // Update state with new reply
       setComments(prev =>
           prev.map(c =>
           c._id === activeCommentId
               ? { ...c, replies: [...(c.replies || []), res.data] }
               : c
           )
       );


       handleReplyClose();
       } catch (err) {
       console.error("Reply error", err);
       }
   };

   if (!mainSocialPost) {
     return <div>Loading post...</div>;
   }

   //console.log(mainSocialPost);
    let universityLogo = null;
    if (mainSocialPost.topic) {
        const topic = mainSocialPost.topic.toLowerCase();
        if (mainSocialPost.topic === "ucla" || topic.includes("ucla/majors") || topic.includes("ucla/clubs")) {
            universityLogo = "/uploads/universityLogos/logo_UCLA_blue_boxed.png";
        } else if (mainSocialPost.topic === "stanford"|| topic.includes("stanford/majors") || topic.includes("stanford/clubs")) {
            universityLogo = "/uploads/universityLogos/stanford_logo.png";
        } 
    }
//return (<div>testing</div>);
const location = useLocation();
   const source = location.state?.source;
    const navItems = !mainSocialPost?.topic
    ? [
        /*{
            label: "Popular",
            path: "/page1/a",
            matchPaths: ["/page1/a"]
        },
        {
            label: "Following",
            path: "/page1/b",
            matchPaths: ["/page1/b", "/post"]
        },*/
        {
            label: "Popular",
            path: "/mainsocial/popular",
            matchPaths:
            source === "popular"
                ? ["/mainsocial/popular", "/post"]
                : ["/mainsocial/popular"]
        },
        {
            label: "Following",
            path: "/mainsocial/following",
            matchPaths:
            source === "following"
                ? ["/mainsocial/following", "/post"]
                : ["/mainsocial/following"]
        },
        {
            label: "Academia",
            path: "/mainsocial/academia/popular",
            matchPaths: ["/mainsocial/academia/popular"]
        },
        {
            label: "Topic Threads",
            path: "/mainsocial/topicthreads",
            matchPaths: ["/mainsocial/topicthreads"]
        },
        {
            label: "Photos",
            path: "/mainsocial/photos/following",
            matchPaths: ["/photos"]
        },
        {
            label: "Videos",
            path: "/mainsocial/videos/following",
            matchPaths: ["/videos"]
        }
        ]
    : [];

    const navUniversityItems =
        mainSocialPost?.topicType === "university"
            ? [
                {
                    label: "Popular Academia",
                    path: "/mainsocial/academia/popular",
                    matchPaths: ["/mainsocial/academia/popular"]
                },
                {
                    label: "University",
                    path: "/mainsocial/academia/university",
                    matchPaths: [
                        "/mainsocial/academia/university",
                        "/post"
                    ]
                },
                {
                    label: "Academic Subjects",
                    path: "/mainsocial/academia/academicsubjects",
                    matchPaths: ["/mainsocial/academia/academicsubjects"]
                }
            ]
    : [];
    const navAcademicSubjectItems =
        mainSocialPost?.topicType === "academicSubject"
            ? [
                {
                    label: "Popular Academia",
                    path: "/mainsocial/academia/popular",
                    matchPaths: ["/mainsocial/academia/popular"]
                },
                {
                    label: "University",
                    path: "/mainsocial/academia/university",
                    matchPaths: [
                        "/mainsocial/academia/university",
                    ]
                },
                {
                    label: "Academic Subjects",
                    path: "/mainsocial/academia/academicsubjects",
                    matchPaths: ["/mainsocial/academia/academicsubjects","/post"]
                }
            ]
    : [];   

   const isActive = (item) => {
       return item.matchPaths.some((match) =>
           location.pathname.startsWith(match)
       );
       };


       const getButtonStyles = (item) => {
       const active = isActive(item);


       return {
           padding: "6px 12px",
           borderColor: active ? "#1f1f1f" : "#333333",
           color: active ? "#1f1f1f" : "#333333",
           backgroundColor: active ? "rgba(0,0,0,0.08)" : "transparent",
           fontWeight: active ? 600 : 500,
           transition: "all 0.15s ease",
           "&:hover": {
           borderColor: "black",
           color: "black",
           backgroundColor: "rgba(0,0,0,0.12)"
           }
       };
   };

    const navThreadItems =
        mainSocialPost?.topicType === "thread"
            ? [
                { label: "Popular", path: "/mainsocial/popular" },
                { label: "Following", path: "/mainsocial/following" },
                { label: "Academia", path: "/mainsocial/academia/popular" },
                { label: "Topic Threads", path: "/mainsocial/topicthreads", matchPaths: ["/mainsocial/topicthreads", "/post"] },
                { label: "Photos", path: "/mainsocial/photos/following" },
                { label: "Videos", path: "/mainsocial/videos/following" }
            ]
    : [];

    const getThreadButtonStyles = (item) => {
      //const active = location.pathname.startsWith(path);
      const active = item.matchPaths
        ? item.matchPaths.some(path => location.pathname.startsWith(path))
        : location.pathname.startsWith(item.path);

      return {
        padding: "6px 12px",
        borderColor: active ? "#1f1f1f" : "#333333",
        color: active ? "#1f1f1f" : "#333333",
        backgroundColor: active ? "rgba(0,0,0,0.08)" : "transparent",
        fontWeight: active ? 600 : 500,
        transition: "all 0.15s ease",
        "&:hover": {
          borderColor: "black",
          color: "black",
          backgroundColor: "rgba(0,0,0,0.12)"
        }
      };
    };
return (
       <div
          style={{
              padding: '20px',
              backgroundColor: '#FFFDF8',
              minHeight: '100vh',  // ensures it covers the full viewport height
              boxSizing: 'border-box', // ensures padding doesn't affect layout
          }}
      >

          <div style={{ width: '200px' }}></div>

          {/*{mainSocialPost?.topic ? (
            <Box 
                display="flex" 
                onClick={() => history.push(`/topics/${mainSocialPost.topic}`)}
                justifyContent="center" 
                mt={2} 
                mb={2}
                sx={{
                       cursor: "pointer",
                }}
            >
                <img 
                    src={universityLogo} 
                    style={{
                        maxWidth: "300px",   // limit width
                        height: "auto",      // keep proportions
                        objectFit: "contain" // avoid stretching
                    }}
                />
            </Box>
          ) : (
           
        

          <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              gap={2}
              flexWrap="wrap"
              sx={{
                  mt: 4,
                  mb: 4,
              }}
                  >
                    <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page1/a')}
                   >
                       Popular
                   </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page1/b')}
                   >
                       Following
                   </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page1/c')}
                   >
                       Academia
                   </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page1/d')}
                   >
                       Topic Threads
                   </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/photos')}
                   >
                       Photos
                   </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/videos')}
                   >
                       Videos
                   </Button>
           </Box>
        )}*/}
        {mainSocialPost?.topicType === "university" && (
            <Box
                sx={{
                position: "sticky",
                top: 0,
                zIndex: 1000,
                backgroundColor: "#FFFDF8",
                py: 2
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        maxWidth: "100%",
                    }}
                >
                    {/* LEFT — LOGO */}
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            minWidth: 220, // keeps layout stable
                        }}
                    >
                        <Tooltip
                            title="Lady Wisdom"
                            arrow
                            followCursor
                        >
                            <Box
                                component="img"
                                src="/Colloquia_Logo.png"
                                alt="Colloquia Logo"
                                onClick={() => history.push("/home")}
                                sx={{
                                    height: 90,
                                    width: "auto",
                                    borderRadius: "10px", // rounded edges
                                    cursor: "pointer",
                                    objectFit: "contain",
                                }}
                            />
                        </Tooltip>
                    </Box>
                <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                gap={2}
                flexWrap="wrap"
                >
                {navUniversityItems.map((item) => (
                    <Button
                    key={item.path}
                    variant="outlined"
                    sx={getButtonStyles(item)}
                    onClick={() => history.push(item.path)}
                    >
                    {item.label}
                    </Button>
                ))}
                </Box>
                <Box sx={{ minWidth: 220 }} />
              </Box>
            </Box>
            )}

        {mainSocialPost?.topicType === "academicSubject" && (
            <Box
                sx={{
                position: "sticky",
                top: 0,
                zIndex: 1000,
                backgroundColor: "#FFFDF8",
                py: 2
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        maxWidth: "100%",
                    }}
                >
                    {/* LEFT — LOGO */}
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            minWidth: 220, // keeps layout stable
                        }}
                    >
                        <Tooltip
                            title="Lady Wisdom"
                            arrow
                            followCursor
                        >
                            <Box
                                component="img"
                                src="/Colloquia_Logo.png"
                                alt="Colloquia Logo"
                                onClick={() => history.push("/home")}
                                sx={{
                                    height: 90,
                                    width: "auto",
                                    borderRadius: "10px", // rounded edges
                                    cursor: "pointer",
                                    objectFit: "contain",
                                }}
                            />
                        </Tooltip>
                    </Box>
                <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                gap={2}
                flexWrap="wrap"
                >
                {navAcademicSubjectItems.map((item) => (
                    <Button
                    key={item.path}
                    variant="outlined"
                    sx={getButtonStyles(item)}
                    onClick={() => history.push(item.path)}
                    >
                    {item.label}
                    </Button>
                ))}
                </Box>
                <Box sx={{ minWidth: 220 }} />
              </Box>
            </Box>
            )}

        {mainSocialPost?.topicType === "thread" && (
            <Box
                sx={{
                position: "sticky",
                top: 0,
                zIndex: 1000,
                backgroundColor: "#FFFDF8",
                py: 2
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        maxWidth: "100%",
                    }}
                >
                    {/* LEFT — LOGO */}
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            minWidth: 220, // keeps layout stable
                        }}
                    >
                        <Tooltip
                            title="Lady Wisdom"
                            arrow
                            followCursor
                        >
                            <Box
                                component="img"
                                src="/Colloquia_Logo.png"
                                alt="Colloquia Logo"
                                onClick={() => history.push("/home")}
                                sx={{
                                    height: 90,
                                    width: "auto",
                                    borderRadius: "10px", // rounded edges
                                    cursor: "pointer",
                                    objectFit: "contain",
                                }}
                            />
                        </Tooltip>
                    </Box>
                <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                gap={2}
                flexWrap="wrap"
                >
                {navThreadItems.map((item) => (
                    <Button
                    key={item.path}
                    variant="outlined"
                    sx={getThreadButtonStyles(item)}
                    onClick={() => history.push(item.path)}
                    >
                    {item.label}
                    </Button>
                ))}
                </Box>
                <Box sx={{ minWidth: 220 }} />
              </Box>
            </Box>
            )}

        {mainSocialPost?.topicType === "academicSubject" && (
            <Box 
                display="flex" 
                onClick={() => history.push(`/mainsocial/academia/academicsubjects/${mainSocialPost?.topic}`)}
                justifyContent="center" 
                mt={2} 
                mb={2}
                sx={{
                       cursor: "pointer",
                }}
            >
                <Typography variant="h4">c/{mainSocialPost?.topic}</Typography>
            </Box>
        )}
        {mainSocialPost?.topicType === "thread" && (
            <Box 
                display="flex" 
                onClick={() => history.push(`/mainsocial/topicthreads/${mainSocialPost?.topic}`)}
                justifyContent="center" 
                mt={2} 
                mb={2}
                sx={{
                       cursor: "pointer",
                }}
            >
                <Typography variant="h4">c/{mainSocialPost?.topic}</Typography>
            </Box>
        )}
        {/*{mainSocialPost?.topic ? (
            <Box 
                display="flex" 
                onClick={() => history.push(`/topics/${mainSocialPost.topic}`)}
                justifyContent="center" 
                mt={2} 
                mb={2}
                sx={{
                       cursor: "pointer",
                }}
            >
                <Typography variant="h4">c/{mainSocialPost.topic}</Typography>
            </Box>
          ) : (*/}
           {mainSocialPost?.topicType === "university" && (
            <Box 
                display="flex" 
                onClick={() => history.push(`/mainsocial/academia/university/${mainSocialPost.topic}`)}
                justifyContent="center" 
                mt={2} 
                mb={2}
                sx={{
                       cursor: "pointer",
                }}
            >
                <Typography variant="h4">
                    c/{mainSocialPost.topic
                        .split("/")
                        .filter(segment => segment !== "majors" && segment !== "clubs")
                        .join("/")}
                </Typography>
            </Box>
            )} 
        
        {mainSocialPost?.topicType != "university" && mainSocialPost?.topicType != "academicSubject" && mainSocialPost?.topicType != "thread" && (
          <Box
                sx={{
                    position: "sticky",
                    top: 0,
                    zIndex: 1000,
                    backgroundColor: "#FFFDF8",
                    py: 2
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        maxWidth: "100%",
                    }}
                >
                    {/* LEFT — LOGO */}
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            minWidth: 220, // keeps layout stable
                        }}
                    >
                        <Tooltip
                            title="Lady Wisdom"
                            arrow
                            followCursor
                        >
                            <Box
                                component="img"
                                src="/Colloquia_Logo.png"
                                alt="Colloquia Logo"
                                onClick={() => history.push("/home")}
                                sx={{
                                    height: 90,
                                    width: "auto",
                                    borderRadius: "10px", // rounded edges
                                    cursor: "pointer",
                                    objectFit: "contain",
                                }}
                            />
                        </Tooltip>
                    </Box>
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    gap={2}
                    flexWrap="wrap"
                >
                    {navItems.map((item) => (
                    <Button
                        key={item.path}
                        variant="outlined"
                        sx={getButtonStyles(item)}
                        onClick={() => history.push(item.path)}
                    >
                        {item.label}
                    </Button>
                    ))}
                </Box>
                <Box sx={{ minWidth: 220 }} />
              </Box>
            </Box>
        )}
           <Box
               p={2} // padding inside box
               my={2} // vertical margin between posts
               border="1px solid #ccc" // light grey border
               borderRadius="8px" // rounded corners
               sx={{
                   position: "relative",
                   maxWidth: 900, // limit width
                   mx: "auto", // center horizontally
                   my: 2, // vertical spacing between each post
               }}
           >
                <Box display="flex" alignItems="flex-start" gap={1}>
                       <Avatar
                           src={mainSocialPost.author?.profileImageUrl || '/default-avatar.jpg'}
                           alt={`${mainSocialPost.author?.first_name || ''} ${mainSocialPost.author?.last_name || ''}`}
                           onClick={(e) => visitProfile(e, mainSocialPost.author?._id)}
                           sx={{ 
                            width: 62, 
                            height: 62,
                            cursor: "pointer",
                            "&:hover": {
                                backgroundColor: "#d9e4f0",
                            }, 
                            }}
                       />
                       <Box>
                           <Typography variant="subtitle1" fontWeight="bold"
                           onClick={(e) => visitProfile(e, mainSocialPost.author?._id)}
                                sx={{
                                    cursor: "pointer",
                                    display: "inline-block",
                                    "&:hover": {
                                    textDecoration: "underline",
                                    textDecorationColor: "currentColor", 
                                    textUnderlineOffset: "3px",
                                    },
                                }}
                           >
                           {mainSocialPost.author?.first_name && mainSocialPost.author?.last_name
                               ? `${mainSocialPost.author.first_name} ${mainSocialPost.author.last_name}`
                               : 'Unknown Name'}
                           </Typography>
                           <Typography variant="body2" color="text.secondary"
                           onClick={(e) => visitProfile(e, mainSocialPost.author?._id)}
                                sx={{
                                    cursor: "pointer",
                                    display: "block",
                                    "&:hover": {
                                    textDecoration: "underline",
                                    textDecorationColor: "#currentColor",
                                    textUnderlineOffset: "3px",
                                    },
                                }}
                           >
                           @{mainSocialPost.author?.username || 'unknown'}
                           </Typography>



                           <Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
                               {mainSocialPost.content}
                           </Typography>


            
                           <Typography
                                variant="caption"
                                color="text.secondary"
                                sx={{ display: "block", mt: 0.5 }}
                            >
                                {`${new Date(mainSocialPost.created_at).toLocaleString()}, ${
                                    mainSocialPost.commentCount
                                } ${mainSocialPost.commentCount === 1 ? 'reply' : 'replies'}`}
                            </Typography>


                       </Box>
                   </Box>

                   {/*<Box mt={2} display="flex" alignItems="center" gap={1}>
                       <Button
                           size="small"
                           variant={mainSocialPost.voted ? "contained" : "outlined"}
                           //onClick={() => toggleVote(post._id)}
                           onClick={(e) => {
                               e.stopPropagation();
                               toggleVote(mainSocialPost._id)}
                           }
                       >
                           ▲ {mainSocialPost.voted ? "Unvote" : "Upvote"}
                       </Button>
                       <Typography variant="body2">{mainSocialPost.upvotes} upvotes</Typography>
                   </Box>*/}
                   <Box mt={2} display="flex" alignItems="center" gap={1}>
                        {mainSocialPost.voted ? (
                            <Box
                               sx={{
                                   position: "relative",
                                   display: "inline-flex",
                                   alignItems: "center",
                                   "&:hover .voted-btn": {
                                       opacity: 0,
                                   },
                                   "&:hover .undo-btn": {
                                       opacity: 1,
                                       pointerEvents: "auto",
                                   },
                               }}
                           >
                                <Button
 					                size="small"
                                    className="voted-btn"
                                    variant="contained"
                                    color="success"
                                    disabled
                                    sx={{
                                       transition: "opacity 0.2s ease",
                                    }}
                                >
                                   Power Voted
                               </Button>
                               <Button
                                    size="small"
                                    className="undo-btn"
                                    variant="contained"
                                    color="error"
                                    sx={{
                                       inset: 0,
                                       position: "absolute",
                                       transition: "opacity 0.2s ease",
                                       opacity: 0,
                                       pointerEvents: "none",
                                   }}
                                   onClick={(e) => {
                                       e.stopPropagation();
                                       toggleVote(mainSocialPost._id)
                                   }}
                               >
                                    Undo
                               </Button>
                           </Box>
                        ) : (
                            <Button
                                size="small"
                                variant="outlined"
                                onClick={(e) => {
                                e.stopPropagation();
                                toggleVote(mainSocialPost._id)}
                            }
                            >
                                ▲ Power Vote
                            </Button>
                        )}
                        <Typography variant="body2">{mainSocialPost.upvotes} Power Votes</Typography>
                   </Box>
           </Box>

           <Box
               p={2} // padding inside box
               my={2} // vertical margin between posts
               border="1px solid #ccc" // light grey border
               borderRadius="8px" // rounded corners
               sx={{
                   position: "relative",
                   maxWidth: 900, // limit width
                   mx: "auto", // center horizontally
                   my: 2, // vertical spacing between each post
               }}
           >
           <TextField
               fullWidth
               multiline
               rows={2}
               placeholder="Engage in intellectual discourse..."
               value={newComment}
               onChange={e => setNewComment(e.target.value)}
           />
           <Button variant="outlined" sx={{ mt: 1 }} onClick={handleSubmitComment}>
               Reply
           </Button>
           </Box>




           {comments.length === 0 ? (
               <Typography></Typography>
           ) : (
               comments.map((comment, i) => {
                const isLast = i === comments.length - 1;

                return (
                    <Box
                    key={comment._id}
                    ref={isLast ? lastCommentRef : null}
                   p={2} // padding inside box
                   //onClick={() => history.push(`/mainSocial/${id}/comments/${comment._id}`)}
                   onClick={() => history.push(`/mainSocial/${id}/comments/${comment._id}`, { source: source })}
                   my={2} // vertical margin between posts
                   border="1px solid #ccc" // light grey border
                   borderRadius="8px" // rounded corners
                   sx={{
                       position: "relative",
                       maxWidth: 900, // limit width
                       mx: "auto", // center horizontally
                       my: 2, // vertical spacing between each post
                       cursor: "pointer",
                       "&:hover": {
                           backgroundColor: "#f9f9f9"
                       }
                   }}
           >




                   <Box display="flex" alignItems="flex-start" gap={1}>
                               <Avatar
                                   src={comment.author?.profileImageUrl || '/default-avatar.jpg'}
                                   alt={`${comment.author?.first_name || ''} ${comment.author?.last_name || ''}`}
                                   onClick={(e) => visitProfile(e, comment.author?._id)}
                                    sx={{ 
                                        width: 62, 
                                        height: 62,
                                        cursor: "pointer",
                                        "&:hover": {
                                            backgroundColor: "#d9e4f0",
                                        }, 
                                        }}
                               />
                               <Box>
                                   <Typography variant="subtitle1" fontWeight="bold"
                                   onClick={(e) => visitProfile(e, comment.author?._id)}
                                    sx={{
                                        cursor: "pointer",
                                        display: "inline-block",
                                        "&:hover": {
                                        textDecoration: "underline",
                                        textDecorationColor: "currentColor", 
                                        textUnderlineOffset: "3px",
                                        },
                                    }}
                                   >
                                   {comment.author?.first_name && comment.author?.last_name
                                       ? `${comment.author.first_name} ${comment.author.last_name}`
                                       : 'Unknown Name'}
                                   </Typography>
                                   <Typography variant="body2" color="text.secondary"
                                   onClick={(e) => visitProfile(e, comment.author?._id)}
                                    sx={{
                                        cursor: "pointer",
                                        display: "block",
                                        "&:hover": {
                                        textDecoration: "underline",
                                        textDecorationColor: "#currentColor",
                                        textUnderlineOffset: "3px",
                                        },
                                    }}
                                   >
                                   @{comment.author?.username || 'unknown'}
                                   </Typography>

                                   <Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
                                       {comment.text}
                                   </Typography>
                                    {/*}
                                   <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.5 }}>
                                       {`${new Date(comment.created_at).toLocaleString()}, ${comment.replies.length} ${comment.replies.length === 1 ? 'reply' : 'replies'}`}
                                       </Typography>*/}
                                    <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
                                        {`${new Date(comment.created_at).toLocaleString()}, ${
                                            comment.replyCount ?? 0
                                        } ${comment.replyCount === 1 ? "reply" : "replies"}`}
                                    </Typography>

                               </Box>
                           </Box>




                           {/*<Box mt={2} display="flex" alignItems="center" gap={1}>
                               <Button
                                   size="small"
                                   variant={comment.voted ? "contained" : "outlined"}
                                   onClick={(e) => {
                                       e.stopPropagation();
                                       toggleCommentVote(comment._id)}
                                   }
                               >
                                   ▲ {comment.voted ? "Unvote" : "Upvote"}
                               </Button>
                               <Typography variant="body2">{comment.upvotes} upvotes</Typography>
                           </Box>*/}
                           <Box mt={2} display="flex" alignItems="center" gap={1}>
                            {comment.voted ? (
                                <Box
                                sx={{
                                    position: "relative",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    "&:hover .voted-btn": {
                                        opacity: 0,
                                    },
                                    "&:hover .undo-btn": {
                                        opacity: 1,
                                        pointerEvents: "auto",
                                    },
                                }}
                            >
                                    <Button
                                        size="small"
                                        className="voted-btn"
                                        variant="contained"
                                        color="success"
                                        disabled
                                        sx={{
                                        transition: "opacity 0.2s ease",
                                        }}
                                    >
                                    Power Voted
                                </Button>
                                <Button
                                        size="small"
                                        className="undo-btn"
                                        variant="contained"
                                        color="error"
                                        sx={{
                                        inset: 0,
                                        position: "absolute",
                                        transition: "opacity 0.2s ease",
                                        opacity: 0,
                                        pointerEvents: "none",
                                    }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        toggleCommentVote(comment._id)
                                    }}
                                >
                                        Undo
                                </Button>
                            </Box>
                            ) : (
                                <Button
                                    size="small"
                                    variant="outlined"
                                    onClick={(e) => {
                                    e.stopPropagation();
                                    toggleCommentVote(comment._id)}
                                }
                                >
                                    ▲ Power Vote
                                </Button>
                            )}
                            <Typography variant="body2">{comment.upvotes} Power Votes</Typography>
                    </Box>


               </Box>
                );
            })
            )}
           <Dialog open={replyOpen} onClose={handleReplyClose}>
           <DialogTitle>Reply to Comment</DialogTitle>
           <DialogContent>
               <TextField
               autoFocus
               fullWidth
               multiline
               minRows={3}
               value={replyText}
               onChange={(e) => setReplyText(e.target.value)}
               placeholder="Write your reply..."
               />
           </DialogContent>
           <DialogActions>
               <Button onClick={handleReplyClose}>Cancel</Button>
               <Button onClick={handleReplySubmit} variant="contained">
               Post Reply
               </Button>
           </DialogActions>
           </Dialog>


    </div>
);
{/*}
   return (
       <div
          style={{
              padding: '20px',
              backgroundColor: '#FFFDF8',
              minHeight: '100vh',  // ensures it covers the full viewport height
              boxSizing: 'border-box', // ensures padding doesn't affect layout
          }}
      >

          <div style={{ width: '200px' }}></div>

          <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              gap={2}
              flexWrap="wrap"
              sx={{
                  mt: 4,
                  mb: 4,
              }}
                  >
                    <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page1/a')}
                   >
                       Popular
                   </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page1/b')}
                   >
                       Following
                   </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page1/c')}
                   >
                       Academia
                   </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page1/d')}
                   >
                       Topic Threads
                   </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/photos')}
                   >
                       Photos
                   </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/videos')}
                   >
                       Videos
                   </Button>
           </Box>

           <Box
               p={2} // padding inside box
               my={2} // vertical margin between posts
               border="1px solid #ccc" // light grey border
               borderRadius="8px" // rounded corners
               sx={{
                   position: "relative",
                   maxWidth: 900, // limit width
                   mx: "auto", // center horizontally
                   my: 2, // vertical spacing between each post
               }}
           >


           	<Box display="flex" alignItems="flex-start" gap={1}>
                       <Avatar
                           src={mainSocialPost.author?.profileImageUrl || '/default-avatar.jpg'}
                           alt={`${mainSocialPost.author?.first_name || ''} ${mainSocialPost.author?.last_name || ''}`}
                           sx={{ width: 62, height: 62 }}
                       />
                       <Box>
                           <Typography variant="subtitle1" fontWeight="bold">
                           {mainSocialPost.author?.first_name && mainSocialPost.author?.last_name
                               ? `${mainSocialPost.author.first_name} ${mainSocialPost.author.last_name}`
                               : 'Unknown Name'}
                           </Typography>
                           <Typography variant="body2" color="text.secondary">
                           @{mainSocialPost.author?.username || 'unknown'}
                           </Typography>



                           <Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
                               {mainSocialPost.content}
                           </Typography>


            
                           <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.5 }}>
                               {new Date(mainSocialPost.created_at).toLocaleString()}
                           </Typography>


                       </Box>
                   </Box>

                   <Box mt={2} display="flex" alignItems="center" gap={1}>
                       <Button
                           size="small"
                           variant={mainSocialPost.voted ? "contained" : "outlined"}
                           //onClick={() => toggleVote(post._id)}
                           onClick={(e) => {
                               e.stopPropagation();
                               toggleVote(post._id)}
                           }
                       >
                           ▲ {mainSocialPost.voted ? "Unvote" : "Upvote"}
                       </Button>
                       <Typography variant="body2">{mainSocialPost.upvotes} upvotes</Typography>
                   </Box>
                </Box>



           <Box
               p={2} // padding inside box
               my={2} // vertical margin between posts
               border="1px solid #ccc" // light grey border
               borderRadius="8px" // rounded corners
               sx={{
                   position: "relative",
                   maxWidth: 900, // limit width
                   mx: "auto", // center horizontally
                   my: 2, // vertical spacing between each post
               }}
           >
           <TextField
               fullWidth
               multiline
               rows={2}
               placeholder="Engage in intellectual discouse..."
               value={newComment}
               onChange={e => setNewComment(e.target.value)}
           />
           <Button variant="outlined" sx={{ mt: 1 }} onClick={handleSubmitComment}>
               Submit Comment
           </Button>
           </Box>




           {comments.length === 0 ? (
               <Typography>No comments yet.</Typography>
           ) : (
               comments.map((comment, i) => (
               <Box
                   p={2} // padding inside box
                   onClick={() => history.push(`/scotusCase/${id}/comments/${comment._id}`)}
                   my={2} // vertical margin between posts
                   border="1px solid #ccc" // light grey border
                   borderRadius="8px" // rounded corners
                   sx={{
                       position: "relative",
                       maxWidth: 900, // limit width
                       mx: "auto", // center horizontally
                       my: 2, // vertical spacing between each post
                       cursor: "pointer",
                       "&:hover": {
                           backgroundColor: "#f9f9f9"
                       }
                   }}
           >




                   <Box display="flex" alignItems="flex-start" gap={1}>
                               <Avatar
                                   src={comment.author?.profileImageUrl || '/default-avatar.jpg'}
                                   alt={`${comment.author?.first_name || ''} ${comment.author?.last_name || ''}`}
                                   sx={{ width: 62, height: 62 }}
                               />
                               <Box>
                                   <Typography variant="subtitle1" fontWeight="bold">
                                   {comment.author?.first_name && comment.author?.last_name
                                       ? `${comment.author.first_name} ${comment.author.last_name}`
                                       : 'Unknown Name'}
                                   </Typography>
                                   <Typography variant="body2" color="text.secondary">
                                   @{comment.author?.username || 'unknown'}
                                   </Typography>

                                   <Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
                                       {comment.text}
                                   </Typography>

                                   <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.5 }}>
                                       {`${new Date(comment.created_at).toLocaleString()}, ${comment.replies.length} ${comment.replies.length === 1 ? 'reply' : 'replies'}`}
                                       </Typography>

                               </Box>
                           </Box>




                           <Box mt={2} display="flex" alignItems="center" gap={1}>
                               <Button
                                   size="small"
                                   variant={comment.voted ? "contained" : "outlined"}
                                   onClick={(e) => {
                                       e.stopPropagation();
                                       toggleCommentVote(comment._id)}
                                   }
                               >
                                   ▲ {comment.voted ? "Unvote" : "Upvote"}
                               </Button>
                               <Typography variant="body2">{comment.upvotes} upvotes</Typography>
                           </Box>


               </Box>
               ))
           )}
           <Dialog open={replyOpen} onClose={handleReplyClose}>
           <DialogTitle>Reply to Comment</DialogTitle>
           <DialogContent>
               <TextField
               autoFocus
               fullWidth
               multiline
               minRows={3}
               value={replyText}
               onChange={(e) => setReplyText(e.target.value)}
               placeholder="Write your reply..."
               />
           </DialogContent>
           <DialogActions>
               <Button onClick={handleReplyClose}>Cancel</Button>
               <Button onClick={handleReplySubmit} variant="contained">
               Post Reply
               </Button>
           </DialogActions>
           </Dialog>




       </div>


   );
*/}


}


export default MainSocialCommentsPage;
